import { call, put, takeLatest } from 'redux-saga/effects';

import LabPanelsService from 'shared/services/LabPanelsService';
import { failAction, getLabPanels, setLabPanels } from './labPanels.redux';
import { ILabPanel } from 'shared/interfaces/labPanel.interface';
import { TAction } from 'shared/types';

function* getLabPanelsSaga({ payload }: TAction<{ lab: string }>) {
  try {
    const result: ILabPanel[] = yield call(
      LabPanelsService.getLabPanels,
      payload
    );
    yield put(setLabPanels(result));
  } catch (error) {
    console.log('error', error);
    yield put(failAction());
  }
}

function* LabPanels() {
  yield takeLatest(getLabPanels.type, getLabPanelsSaga);
}

export default LabPanels;
